import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { from, Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private storage_user: Storage | null = null;
  private token: string = '';

  constructor(private storage: Storage) {}

  async init() {
    this.token = '';
    const storage = await this.storage.create();
    this.storage_user = storage;
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isApiUrl = request.url.startsWith(environment.apiUrl);
    //const isPaises = request.url.endsWith('medico/medico/getpaises');

    if (isApiUrl) {
      return from(this.handle(request, next));
    }

    return next.handle(request);
  }

  async handle(req: HttpRequest<any>, next: HttpHandler) {
    await this.init();
    await this.storage_user?.get(environment.localStorage).then((res) => {
      if (res?.token) {
        this.token = res.token;
      }
    });

    if (this.token) {
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${this.token}`,
        },
      });
      // Important: Note the .toPromise()
      return next.handle(authReq).toPromise();
    } else {
      return next.handle(req).toPromise();
    }
  }
}
